export const services = {
    INTERNAL_TRANSFER: 'internal_transfer',
    PAYA_TRANSFER: 'paya_transfer',
    SATNA_TRANSFER: 'satna_transfer',
    CARD_TO_IBAN: 'card_to_iban',
    // CARD_TO_ACCOUNT: 'card_to_account',
    IBAN_TO_ACCOUNT: 'iban_to_account',
    ACCOUNT_TO_IBAN: 'account_to_iban',
    INVOICE: 'invoice',
    // SATNA_REPORT: 'satna_report',
    // PAYA_REPORT: 'paya_report',
    MATCHING_NATIONAL_ID_MOBILE: 'matching_national_id_mobile',
    // POSTAL_CODE_INFORMATION: 'postal_code_information',
    IBAN_INQUIRY: 'iban_inquiry',
    // CARD_OWNER_INFORMATION_INQUIRY: 'card_owner_information_inquiry',
    // ACCOUNT_OWNER_NAME_INQUIRY: 'account_owner_name_inquiry',
    // CARD_INQUIRY: 'card_inquiry',
    MATCHING_CARD_NATIONAL_ID_BIRTH_DATE_INQUIRY: 'matching_card_national_id_birth_date_inquiry',
    MATCHING_IBAN_NATIONAL_ID_BIRTH_DATE_INQUIRY: 'matching_iban_national_id_birth_date_inquiry',
    MATCHING_IBAN_NATIONAL_ID_INQUIRY: 'matching_iban_national_id_inquiry',
    BALANCE: 'balance',
    UPDATE_SUBSCRIPTION: 'update_subscription',
    VITAL_INFO: 'vital_info',
    STATEMENT: 'statement',
    IPG_GATEWAY_TRANSACTION_REFUND: 'ipg_gateway_transaction_refund',
}
